import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { MicroLabel } from "@/shared/operator";
import { MONO_FONT } from "@/shared/typography";

interface MetricCardProps {
  label: string;
  value: React.ReactNode;
  hint?: React.ReactNode;
  hintColor?: "success" | "warning" | "error" | "text.secondary";
  icon?: React.ReactNode;
  onClick?: () => void;
}

export const MetricCard: React.FC<MetricCardProps> = ({
  label, value, hint, hintColor = "text.secondary", icon, onClick,
}) => (
  <Box
    onClick={onClick}
    role={onClick ? "button" : undefined}
    tabIndex={onClick ? 0 : undefined}
    onKeyDown={
      onClick
        ? (e: React.KeyboardEvent<HTMLElement>) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              onClick();
            }
          }
        : undefined
    }
    sx={{
      bgcolor: "background.paper",
      border: "0.5px solid",
      borderColor: "divider",
      borderRadius: 2,
      p: 1.5,
      cursor: onClick ? "pointer" : "default",
      transition: "border-color 0.15s",
      "&:hover": onClick ? { borderColor: "primary.main" } : undefined,
      "&:focus-visible": onClick
        ? { outline: "2px solid", outlineColor: "primary.main", outlineOffset: 2 }
        : undefined,
    }}
  >
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
      {icon != null && <Box aria-hidden="true" sx={{ fontSize: 14, lineHeight: 1 }}>{icon}</Box>}
      <MicroLabel>{label}</MicroLabel>
    </Box>
    <Typography
      sx={{ fontSize: 20, fontWeight: 600, fontFamily: MONO_FONT, mt: 0.5, lineHeight: 1.1 }}
    >
      {value}
    </Typography>
    {hint != null && (
      <Typography sx={{ fontSize: 11, color: hintColor, mt: 0.5 }}>{hint}</Typography>
    )}
  </Box>
);
